import SignInComponent from "../../components/SignInComponent/SignInComponent";
import styles from "./SignInPage.module.css";

const SignInPage = () => {
    return ( 
        <div className={styles.Wrapper}>
            <SignInComponent />
        </div>
     );
}
 
 
export default SignInPage;

